<template>
  <div class="battery-store__wrapper">
    <div class="css-grid battery-store__header">
      <div class="battery-store__header-name">Fuel Battery Partners</div>
    </div>
    <div>
      <div class="battery-order-view__container battery-order-view__container--form">
        <div style="padding: 30px">
          <p>Fuel Medical Group is proud to offer access to high-quality, mercury-free batteries now directly through ReSound and Starkey. Our members can enjoy the reliability of Rayovac’s top-tier materials, a sturdy design and a higher capacity than standard mercury batteries, which translates to a longer shelf life and satisfied patients.</p>
          <p>Both ReSound and Starkey offer standard and private-label batteries. For more information on pricing, how to order and private labeling from each manufacturer, please see below.</p>
          <div style="padding:15px;">
            <img width="250px" src="/images/battery-store/ReSound_logo.svg" />
          </div>
          <p>ReSound offers Rayovac Proline Advanced batteries in the following four sizes: 675, 312, 13 and 10A. They offer 10 cards of six with a minimum order quantity of 10 cartons per order. The pricing starts at $0.21 per cell or $12.80 per carton. Private labeling is included upon request.</p>
          <p>Please see the following instructions below on how to order private-label batteries from ReSound:</p>
          <ol>
            <li>Submit the image, logo or specific colors you’d like to have on the label to your GN ReSound customer care rep.</li>
            <li>Review the artwork for approval. Confirm your clinic name, address and phone number are correct.</li>
            <li>Upon approval, your order will be submitted.</li>
            <li>Please allow one to two days before you start ordering your private-label batteries.</li>
            <li>Please call your GN ReSound customer care rep at 1-800-248-4327 when you place orders.</li>
          </ol>

          <p>Non private label batteries can be ordered online through your account at <a href="mailto:pro.resound.com">pro.resound.com</a>.</p>

          <div style="padding:15px 0;">
            <img style="width:250px; height:150px;" src="/images/battery-store/starkey-logo.svg" />
          </div>

          <p>Starkey offers Rayovac batteries for our members at $0.21 per cell or $12.60 per carton. They offer a six-pack, long tab in a 60-count and a cochlear option for $30, which is a 60-count.</p>
          <p>Custom private labeling is offered, but there is a one-time setup fee of $30. Creation of the label takes five business days. Alternative options are a blank label or a Starkey label.</p>
          <p>Members have the choice to ship via UPS, choosing between Ground, 2nd day and Overnight, with varying pricing for shipping. Shipping is cut off daily at 1 p.m.</p>
          <p>To order Rayovac batteries through Starkey, please call 1-800-328-8602 or email Bruce Himple at <a href="mailto:bruce_himple@starkey.com">bruce_himple@starkey.com</a>.</p>

          <p><span style="font-size:10px">For all Rayovac batteries, all sizes come in new child-proof packaging as required by FDA Reese’s Law, effective 5/8/2024.</span></p>

          <div class="battery-store__footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BatteryStoreLayout',
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
